module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00077.ee82d99.png";